import { StateType } from '../index';
import Immutable from 'immutable';
import { Operator } from '../../shared/api/api';
import { ImmutableInterface } from '../../types';

export const fastExpressionFetchingSelector = (state: StateType) => state.getIn(['fast_expression', 'fetching']) as boolean;

export const fastExpressionOperatorsSelector = (state: StateType) =>
  state.getIn(['fast_expression', 'operators']) as Immutable.List<ImmutableInterface<Operator>> | undefined;
